import { NavLink } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className='footer'>
            <ul className='footer__list'>
                <li className='footer__list-item'>
                    <NavLink className='footer__list-link' activeClassName='footer__list-link--active' to='/terms'>Условия и положения</NavLink>
                </li>
                <li className='footer__list-item'>
                    <NavLink className='footer__list-link' activeClassName='footer__list-link--active' to='/confidentiality'>Политика конфиденциальности</NavLink>
                </li>
                <li className='footer__list-item'>
                    <NavLink className='footer__list-link' activeClassName='footer__list-link--active' to='/faq'>FAQ</NavLink>
                </li>
                <li className='footer__list-item'>
                    Разработано <a className='footer__developedby' href="https://gasmg.ru" target='_blank'>gasmg</a>
                </li>
            </ul>
            <ul className='footer__social'>
                <li className='footer__social-item footer__social-item--facebook'></li>
                <li className='footer__social-item footer__social-item--twitter'></li>
                <li className='footer__social-item footer__social-item--linkedin'></li>
                <li className='footer__social-item footer__social-item--instagram'></li>
                <li className='footer__social-item footer__social-item--pinterest'></li>
            </ul>
            <p className='footer__copy'>© ООО «Кино со вкусом», 2021</p>
        </footer>
    );
};

export default Footer;